import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
export const withToaster = (component) => () => (_jsxs(_Fragment, { children: [_jsx(ToastContainer, { position: "top-center", autoClose: 5000, closeButton: false, hideProgressBar: true, newestOnTop: false, closeOnClick: true, icon: false, rtl: false, draggable: true, pauseOnHover: true, theme: "dark" }), component()] }));
